import { connect } from 'react-redux'
import { IStoreState } from '../../types'

import ServicesSearch from '../../components/services/list/ServicesSearch'
import { fetchServiceList, search } from '../../state/actions/services'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    orgId: state.organizations.currentOrgId,
    type: ownProps.type
  }
}

export function mapDispatchToProps(dispatch: any): any {
  return {
    onInputChange: (orgId: string, query: string, type: string) => {
      if (query.length === 0) {
        dispatch(fetchServiceList(type, orgId))
      } else {
        dispatch(search(orgId, query, type))
      }
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServicesSearch)



// WEBPACK FOOTER //
// ./src/containers/services/ServicesSearch.ts